// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab1-component {
  font-family: Arial, sans-serif;
  padding: 20px;
  background-color: white;
}

.tab1-content-container {
  display: flex;
  justify-content: space-between;
}

.tab1-statistics {
  width: 40%;
  margin-right: 20px;
}

.tab1-chart-container {
  width: 60%;
  height: 300px;
  position: relative;
}

.tab1-input, .tab1-select, .tab1-date-input {
  width: 300px;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  position: relative;
}

.tab1-select-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 40px;
  margin-bottom: 20px;
  position: relative;
}

.tab1-select {
  position: absolute;
}

.tab1-button-container {
  display: flex;
  gap: 10px;
}

.tab1-button-newline-container {
  margin-top: 10px;
}

.tab1-button {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
}

.tab1-button:hover {
  background-color: #0056b3;
  transform: translateY(-2px);
}

.tab1-button:active {
  transform: translateY(0);
  background-color: #004494;
}

.tab1-button-save {
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  margin-top: 10px;
}

.tab1-button-save:hover {
  background-color: #218838;
  transform: translateY(-2px);
}

.tab1-button-save:active {
  transform: translateY(0);
  background-color: #1e7e34;
}`, "",{"version":3,"sources":["webpack://./src/components/survey/tab1/Tab1.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B","sourcesContent":[".tab1-component {\n  font-family: Arial, sans-serif;\n  padding: 20px;\n  background-color: white;\n}\n\n.tab1-content-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.tab1-statistics {\n  width: 40%;\n  margin-right: 20px;\n}\n\n.tab1-chart-container {\n  width: 60%;\n  height: 300px;\n  position: relative;\n}\n\n.tab1-input, .tab1-select, .tab1-date-input {\n  width: 300px;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.tab1-select-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 40px;\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.tab1-select {\n  position: absolute;\n}\n\n.tab1-button-container {\n  display: flex;\n  gap: 10px;\n}\n\n.tab1-button-newline-container {\n  margin-top: 10px;\n}\n\n.tab1-button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 10px 15px;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s;\n}\n\n.tab1-button:hover {\n  background-color: #0056b3;\n  transform: translateY(-2px);\n}\n\n.tab1-button:active {\n  transform: translateY(0);\n  background-color: #004494;\n}\n\n.tab1-button-save {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 10px 15px;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s;\n  margin-top: 10px;\n}\n\n.tab1-button-save:hover {\n  background-color: #218838;\n  transform: translateY(-2px);\n}\n\n.tab1-button-save:active {\n  transform: translateY(0);\n  background-color: #1e7e34;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
